import { React } from 'react';

function Tank(props) {
  return (
    <div className="project-content-container" id="tank-project-content-container">
      <div className="project-content-container-section project-overview">
        <h1>Overview</h1>
        <p>A remote-controlled Arduino toy tank with armor built out of cardboard, this project commenced the epic saga of my struggles with the infamous hobbyist radio module: the nRF24L01. Sourced from the mysterious vendors on amazon.com, this module would haunt my dreams in the many years to come.</p>
        <img alt="" src={null} />
      </div>
    </div>
  );
}

export default Tank;